import { $t } from "@/plugins/i18n"
import { replaceHtmlTagsV2 } from "@/utils/helpers"

import { Status } from "../Status"
import { Notification } from "./Notification"

export class NotificationItem extends Notification {
  constructor(props) {
    super(props)
  }

  get item() {
    return this.content?.item
  }

  get items() {
    return this.content?.items
  }

  get tasks() {
    return this.content?.tasks ?? []
  }

  get taskNames() {
    return this.tasks.map(x => x.name.replace(/<\/?[a-zA-Z]+>/gi, ""))
  }

  get oldItem() {
    return this.content?.oldItem
  }

  get initiatorFullName() {
    const initiator = this.content?.initiator ?? this.content?.initiators?.[0]
    if (!initiator) return ""
    return initiator.firstName + " " + initiator.lastName
  }

  get itemSequenceNumber() {
    return `#${this.item?.sequenceNumber ?? $t("none")}`
  }

  get itemUrl() {
    return this.item?.url
  }

  get projectName() {
    return this.content?.projectName ?? this.item?.projectName ?? this.item?.project?.name ?? ""
  }

  get teamName() {
    return this.content?.teamName ?? this.item?.teamName ?? this.item?.team?.name ?? ""
  }

  get changeStatusReason() {
    const rawContent = this.content?.changeStatusReason ?? ""
    return replaceHtmlTagsV2(rawContent)
  }

  get attachments() {
    return this.content?.attachmentsMetadata?.attachments || []
  }

  get attachmentsCount() {
    return this.content?.attachmentsMetadata.attachmentsCount ?? 0
  }

  getTaskStatus(task) {
    if (task.estimatedHours === 0) {
      return {
        id: "COMPLETED",
        label: "Completed"
      }
    } else if (task.owner && task.estimatedHours) {
      return {
        id: "IN_PROGRESS",
        label: "In Progress"
      }
    } else {
      return {
        id: "NEW",
        label: "New"
      }
    }
  }

  getStatus(id) {
    if (!id) return $t("none")

    return Status.createById({
      id
    })
  }

  getOldItemValue(value) {
    return this.oldItem?.[value] ?? $t("none")
  }

  getItemValue(value) {
    return this.item?.[value] ?? $t("none")
  }
}
